module.exports = __webpack_public_path__ + "img/tubiao6_334_335.3071a1ca.png";